export default function DownloadDocumentDirective() {
  return {
    restrict: 'E',
    template: require('./download-document.directive.html'),
    scope: {
      documentId: '@',
      atCustomerId: '@',
      downloadName: '@',
      mimeType: '@',
      tooltip: '@',
      tooltipAppendToSelector: '@',
      iconType: '@',
      iconSizeClass: '@',
      iconColorClass: '@',
      cleanseDownloadName: '@',
      ssApp: '@',
    },
    controller: 'DownloadDocumentDirectiveController',
    controllerAs: 'downloadDocumentVM',
    bindToController: true,
    replace: true,
  };
}
